module.exports = "/assets/cf_share.jpg?rXhRhqI";